import { render, staticRenderFns } from "./developer.vue?vue&type=template&id=62633550&scoped=true&"
import script from "./developer.vue?vue&type=script&lang=js&"
export * from "./developer.vue?vue&type=script&lang=js&"
import style0 from "./developer.vue?vue&type=style&index=0&id=62633550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62633550",
  null
  
)

export default component.exports